import emptySplitApi from "../utils/rtk";
import { CommonBody, CountryList } from "../types/General";
import { END_POINTS } from "../constants/urls";

type CommonResponseType = {
  status: number;
  message: string;
};
type GetCountriesResponse = {
  length: number;
  start: number;
  response_object: CountryList[];
  total_records: number;
  from_date?: string;
  to_date?: string;
};

export const countriesApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCountries: builder.mutation<
      CommonResponseType & { data: GetCountriesResponse },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.getAllCountries,
        method: "POST",
        body,
      }),
    }),

    deleteCountry: builder.query<
      CommonResponseType & { data: CountryList },
      { id: number | null }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteCountry}${id}/`,
        method: "DELETE",
      }),
    }),
    changeCountryStatus: builder.mutation<
      CommonResponseType & { data: CountryList },
      { body: CommonBody; id: number }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.countryStatus}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    countryDetails: builder.query<
      CommonResponseType & { data: CountryList | null },
      { id: number }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.countryById}${id}/`,
        method: "GET",
      }),
    }),
    updateCountry: builder.mutation<
      CommonResponseType & { data: CountryList },
      { body: CommonBody; id: number }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateCountry}${id}/`,
        method: "PUT",
        body,
      }),
    }),
    addCountry: builder.mutation<
      CommonResponseType & { data: CountryList },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.addCountry,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetCountriesMutation,
  useLazyCountryDetailsQuery,
  useLazyDeleteCountryQuery,
  useChangeCountryStatusMutation,
  useUpdateCountryMutation,
  useAddCountryMutation,
} = countriesApi;
